import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Upload Avatar", -1)
const _hoisted_2 = { class: "custom-cropper" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ControlButtons = _resolveComponent("ControlButtons")!
  const _component_CustomModal = _resolveComponent("CustomModal")!

  return (_openBlock(), _createBlock(_component_CustomModal, {
    id: "avatar-upload",
    modalClass: "custom-modal_margin-custom",
    onOnOpened: _ctx.opened
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          ref: "editImage",
          src: _ctx.url,
          class: "custom-cropper__image"
        }, null, 8, _hoisted_3)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_ControlButtons, {
        onSave: _ctx.onSave,
        onCancel: _ctx.onCancel
      }, null, 8, ["onSave", "onCancel"])
    ]),
    _: 1
  }, 8, ["onOnOpened"]))
}